export const defaultErrorOptions = {
  errorCodesMap: {
    applicationError: {},
  },
};
